import { render, staticRenderFns } from "./NewInncashLayout.vue?vue&type=template&id=54e7f8fc&scoped=true&"
import script from "./NewInncashLayout.vue?vue&type=script&lang=js&"
export * from "./NewInncashLayout.vue?vue&type=script&lang=js&"
import style0 from "./NewInncashLayout.vue?vue&type=style&index=0&id=54e7f8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7f8fc",
  null
  
)

export default component.exports